import Moment from 'moment';

export default function mapWarehousePackage(apiPackage) {
  const orderDate =
    apiPackage.created_at != null
      ? Moment(apiPackage.created_at).format('YYYY-MM-DD HH:mm')
      : Moment().format('YYYY-MM-DD HH:mm');

  return {
    tracking_number: apiPackage.tracking_number || '',
    mailbox_number: apiPackage.mailboxNumber || '',
    item_name: apiPackage.description || 'Unknown',
    weight: apiPackage.weight != null ? String(apiPackage.weight) : '',
    merchant: apiPackage.consignee || 'Warehouse',
    order_date: orderDate,
    status: 'Arrived At Warehouse',
    courier: 'Other',
    fcost: '0.01',
    cost: '',
  };
}
